import store from '../store/store'
import axios from '../axios'

export default class OpportunityService {

  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------After lazy loading--------------------
  // ----------------------------------------------
  // ----------------------------------------------
  
  getAllActiveOpportunities() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = 'v1/activeOpportunities'
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteQuotationGrade(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/quotationGrade/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  editQuotationGrade(quotationGrade) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!quotationGrade.id) {
          throw new Error('Id must be available for editing.')
        } else {
          var path = '/v1/quotationGrade/' + quotationGrade.id
          
          var response = await axios.put(path, quotationGrade)
          // 
          resolve(response.data)
        }
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveQuotationGrade(quotationGrade) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/quotationGrade'
        
        var response = await axios.post(path, quotationGrade)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getQuotationGrade(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotationGrade/' + id
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
    
  }
  
  getAllActiveQuotationGradesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeQuotationGrades'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeQuotationGrades`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllActiveQuotationGrades() {
    return new Promise(async function(resolve, reject) {
      if (
        store.getters[`commons/activeQuotationGrades`]
        && store.getters[`commons/activeQuotationGrades`].length
      ) {
        resolve(store.getters[`commons/activeQuotationGrades`])
  
      } else {
        try {
          var path = '/v1/activeQuotationGrades'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeQuotationGrades`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }
  
  getAllQuotationGradesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotegrades'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/quotationGrades`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllQuotationGrades() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/quotationGrades`]) {
        resolve(store.getters[`commons/quotationGrades`])
  
      } else {
        try {
          var path = '/v1/quotegrades'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/quotationGrades`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
    
  }

  getOpportunityNotes(oppId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/opportunityNotes/' + oppId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDupEnquiry(body) {
    
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getDupEnquiry'
        
        var response = await axios.post(path, body)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  

  getEnquiries(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/opportunityfilterbypage2/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getQuotes(type, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = `/v1/${type}Orders/1/1000/0/0/*`
        var response = await axios.post(path, filterbody)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }



  getOpportunities(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/opportunityfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------Before Lazy loading-------------------
  // ----------------------------------------------
  // ----------------------------------------------
  

  updateOpportunityStatus(oppId, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/updateOpportunityStatus/' + oppId
        
        var response = await axios.put(path, body)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateOpportunityStatusFromExpireToActive(oppId, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setEnquiryActive/' + oppId
        var response = await axios.put(path, body)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getOpportunityGlobalSearch(filterId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/opportunityGlobalSearch/' + filterId
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getEnquiryHistory(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/recordHistoryEnquiry/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getSavedFilteredEnquiries(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/savedFilteredEnquiries/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  //MBP
  getAllOpportunities() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/opportunities`]) {
        resolve(store.getters[`commons/opportunities`]) 
  
      } else {
        try {
          var path
          var path = '/v1/opportunities'
          
          var response = await axios.get(path)
          // 
          try {
            store.dispatch(`commons/opportunities`, response.data)
          } catch(e) {}

          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getOpportunityQuotes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/allopportunityquotes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllOpportunityQuotes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunityquotes/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getOppQuoteNo() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/oppQuoteNo'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }


  getOpportunity(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunity/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllMbpBranches() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/customermbpbranches'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveOpportunityTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/activeOpportunityTypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllOpportunityTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitytypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  postOpportunityTypes(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitytypes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putOpportunityTypes(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitytypes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteOpportunityTypes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitytypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveOpportunityStatusesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/activeOpportunityStatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeOpportunityStatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActiveOpportunityStatuses() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeOpportunityStatuses`]) {
        resolve(store.getters[`commons/activeOpportunityStatuses`])
  
      } else {
        try {
          var path = '/v1/activeOpportunityStatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activeOpportunityStatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  getAllOpportunityStatusesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitystatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/opportunitystatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllOpportunityStatuses() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/opportunitystatuses`]) {
        resolve(store.getters[`commons/opportunitystatuses`])
  
      } else {
        try {
          var path
          var path = '/v1/opportunitystatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/opportunitystatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  postOpportunityStatuses(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitystatuses'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putOpportunityStatuses(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitystatuses/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteOpportunityStatuses(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunitystatuses/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveProjectTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/activeProjectTypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeprojecttypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveProjectTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeprojecttypes`]) {
        resolve(store.getters[`commons/activeprojecttypes`])
  
      } else {
        try {
          var path
          var path = '/v1/activeProjectTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeprojecttypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllProjectTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/projecttypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/projecttypes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllProjectTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/projecttypes`]) {
        resolve(store.getters[`commons/projecttypes`])
  
      } else {
        try {
          var path
          var path = '/v1/projecttypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/projecttypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  postProjectTypes(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/projecttypes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putProjectTypes(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/projecttypes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteProjectTypes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/projecttypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllActiveProductTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/activeproducttypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeproducttypes`, response.data)
        } catch(e) {}
        
        //{ 'headers': { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` } })
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveProductTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeproducttypes`]) {
        resolve(store.getters[`commons/activeproducttypes`])
  
      } else {
        try {
          var path
          var path = '/v1/activeProductTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeproducttypes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllProductTypesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/productTypes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/producttypes`, response.data)
        } catch(e) {}
        
        //{ 'headers': { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` } })
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllProductTypes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/producttypes`]) {
        resolve(store.getters[`commons/producttypes`])
  
      } else {
        try {
          var path
          var path = '/v1/productTypes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/producttypes`, response.data)
          } catch(e) {}
          
          //{ 'headers': { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` } })
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  postProductTypes(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/productTypes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putProductTypes(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/productTypes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteProductTypes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/productTypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveOpportunity(opportunity) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunity'
        
        var response = await axios.post(path, opportunity)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  saveDuplicateOpportunity(opportunity) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunityconf'
        
        var response = await axios.post(path, opportunity)
        // 
        resolve(response)
      } catch (err) {
        
        reject({ err })
      }
    });
  }

  updateOpportunity(id, opportunity) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunity/' + id
        
        var response = await axios.put(path, opportunity)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteOpportunity(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunity/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getOpportunityInfo(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/opportunity/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomerContacts(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path
        var path = '/v1/customerContacts/' + id

        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  getAllActiveQuoteTypes() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeQuoteTypes'
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updateEnquiryQuoteGrade(oppId, gradeId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunities/' + oppId + '/quoteGrade/' + gradeId
        var response = await axios.put(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updateEnquiryQuoteType(oppId, typeId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunities/' + oppId + '/quoteType/' + typeId
        var response = await axios.put(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAllActiveProjectTypes() {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/activeProjectTypes'
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updateEnquiryProjType(oppId, projTypeId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/opportunities/' + oppId + '/projType/' + projTypeId
        var response = await axios.put(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}